import { render, staticRenderFns } from "./Compliance.vue?vue&type=template&id=98eed9aa&"
import script from "./Compliance.vue?vue&type=script&lang=js&"
export * from "./Compliance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98eed9aa')) {
      api.createRecord('98eed9aa', component.options)
    } else {
      api.reload('98eed9aa', component.options)
    }
    module.hot.accept("./Compliance.vue?vue&type=template&id=98eed9aa&", function () {
      api.rerender('98eed9aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/partners/Compliance.vue"
export default component.exports